import { render, staticRenderFns } from "./MedicineTable.vue?vue&type=template&id=67835498&scoped=true"
import script from "./MedicineTable.vue?vue&type=script&lang=js"
export * from "./MedicineTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67835498",
  null
  
)

export default component.exports